import { Injectable, EventEmitter } from '@angular/core';

import {
    SignalRService,
    SignalREventService,
    DataArray,
    DocumentPartMap,
    Attribute,
    AttributeMaps
} from './../index';

@Injectable()
export class AttributeService {
    public attributesChange: EventEmitter<Attribute[]> = new EventEmitter<Attribute[]>();
    public attributeMapChange: EventEmitter<AttributeMaps> = new EventEmitter<AttributeMaps>();
    public attributes: DataArray<Attribute> = new DataArray<Attribute>(1);

    constructor(
        private _signalRService: SignalRService,
        private _signalREventService: SignalREventService
    ) {
        this.registerOnServerEvents();
    }

    public getAttributes(): void {
        this._signalRService.invoke('GetAttributes');
    }

    public getMaps(attributeId: number): void {
        this._signalRService.invoke('GetAttributeMaps', attributeId);
    }

    public update(map: DocumentPartMap): void {
        this._signalRService.invoke('UpdateDocumentPartMap', map.Id, map.Part, map.Value);
    }

    public create(map: DocumentPartMap): void {
        this._signalRService.invoke('CreateDocumentPartMap', map.AttributeId, map.Part, map.Value);
    }

    public delete(map: DocumentPartMap): void {
        this._signalRService.invoke('DeleteDocumentPartMap', map.Id);
    }

    private onAttributes(info: any): void {
        for (const attribute of info.Data.Attributes) {
            this.attributes.update($.extend(new Attribute(), attribute), true);
        }

        this.attributesChange.emit(this.attributes.Data);
    }

    private onAttributeMaps(info: any): void {
        const maps: AttributeMaps = new AttributeMaps();
        maps.AttributeId = info.Data.AttributeId;

        for (const map of info.Data.Maps) {
            maps.Maps.push($.extend(new DocumentPartMap(), map));
        }

        this.attributeMapChange.emit(maps);
    }

    private registerOnServerEvents() {
        this._signalREventService.registerAdvanced(this, 'attributes', (info: any) => this.onAttributes(info));
        this._signalREventService.registerAdvanced(this, 'attributeMaps', (info: any) => this.onAttributeMaps(info));
    }


    public deregisterOnServerEvents(): void {
        this._signalREventService.deregister('AttributeService');
    }
}
